import { callAPI } from "store";
import {
  FETCH_FEATURE_FLAGS,
  FETCH_FEATURE_FLAGS_SUCCESS,
  FETCH_FEATURE_FLAGS_FAILURE,
} from "./featureFlagsActionTypes";
import {
  SYSTEM,
  AMAZON_ACCOUNT_NAME,
  YARD_DESIGNER_ACCOUNT_NAME,
  APIs,
  FEATURES,
} from "app-constants";

export const fetchFeatureFlags = () => {
  return async (dispatch, getState) => {
    const accountInfo = getState().accountInfo;

    dispatch(fetchFeatureFlagsRequest());

    try {
      const responseJson = await callAPI(accountInfo, APIs.IS_FEATURE_ENABLED, {
        features: FEATURES,
        // When user is logged in Amazon account, call IsFeatureEnabled API with override for YardDesigner account
        // See https://quip-amazon.com/KGkdAqjsCWS4/Yard-Designer-FF for context
        ...(accountInfo.activeAccountName === AMAZON_ACCOUNT_NAME
          ? {
              yardId: { buildingCode: YARD_DESIGNER_ACCOUNT_NAME },
              requester: { system: SYSTEM },
            }
          : {}),
      });

      dispatch(fetchFeatureFlagsSuccess(responseJson));
    } catch (exception) {
      dispatch(fetchFeatureFlagsFailure({ error: exception.message }));
    }
  };
};

const fetchFeatureFlagsRequest = () => {
  return {
    type: FETCH_FEATURE_FLAGS,
  };
};

const fetchFeatureFlagsSuccess = (featureFlags) => {
  return {
    type: FETCH_FEATURE_FLAGS_SUCCESS,
    payload: featureFlags,
  };
};

const fetchFeatureFlagsFailure = (payload) => {
  return {
    type: FETCH_FEATURE_FLAGS_FAILURE,
    payload,
  };
};
